import { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { handleChangeFormName, handleOpenModelForm } from '../../../entities/ComponentsSlice';
import HeaderButtons from '../../../features/header-buttons/HeaderButtons';
import { useMatchedRoute } from '../../../features/header-buttons/hooks/useMatchedRoute';
import style from './HeaderBar.module.scss';

const HeaderBar = ({ headerColorScheme }) => {
  const dispatch = useDispatch();
  const contacts = useSelector(state => state.projectinfo.contacts);
  const { houseId, apartmentId, floorId } = useParams();
  const { pathname } = useLocation();
  const match = useMatchedRoute();

  const [headBarOrderStyle, setHeadBarOrderStyle] = useState(`${style.headerBar__order}`);
  const visualPath =
    (houseId && !apartmentId) || (floorId && !apartmentId) || (pathname.includes('visual') && !apartmentId);

  useLayoutEffect(() => {
    if (
      headerColorScheme === '' ||
      headerColorScheme === 'blackOnTransparent' ||
      headerColorScheme === 'blackOnTransparentTwo' ||
      headerColorScheme === 'blackOnTransparentThree'
    ) {
      if (visualPath) {
        setHeadBarOrderStyle(` ${style.headerBar__order} ${style.headerBarWhite__order} ${style.headerBarWhite__text}`);
      } else {
        setHeadBarOrderStyle(` ${style.headerBar__order} ${style.headerBarWhite__order}`);
      }
    } else {
      setHeadBarOrderStyle(`${style.headerBar__order}`);
    }
  }, [headerColorScheme, pathname]);

  return (
    <div className={style.headerBar}>
      <a className={headBarOrderStyle} href={'tel:' + contacts.phone}>
        {contacts.phone}
      </a>
      <div
        onClick={() => {
          dispatch(handleOpenModelForm(true));
          dispatch(handleChangeFormName('callbackForm'));
        }}
        role='button'
        tabIndex='0'
        data-testid='headerFormOpen'
      >
        <p className={headBarOrderStyle}>Заказать звонок</p>
      </div>
      <HeaderButtons headerColorScheme={headerColorScheme} visual={match !== null} />
    </div>
  );
};

export default HeaderBar;
